import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CustomTable from "@components/CustomTable";
import ExpandedViewRow from "./expandedView";
import myStore from "./store";
import { Observer } from "mobx-react";
import {
  PINNING_INITIAL_STATE,
  TABLE_CONFIG,
  DEFAULT_MONTH_RANGE,
  TRIM_CURRENT_DATE,
  PADSTART,
  ONE_VALUE,
} from "./constants";
import { buildColumns } from "./columns/columnsConfig";
import { buildActions } from "./actions/actionsConfig";
import { ZERO_VALUE } from "../../utils/constants";

const ReconciliationStreamsComponent = () => {
  const [parentSelectedValues, setParentSelectedValues] = useState({});
  const { t: translate, i18n } = useTranslation();

  const [currentDateTime, setCurrentDateTime] = useState("");
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");

  useEffect(() => {
    const today = new Date();
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(today.getMonth() - DEFAULT_MONTH_RANGE);

    const formattedDateTime = today
      .toISOString()
      .slice(ZERO_VALUE, TRIM_CURRENT_DATE);
    setCurrentDateTime(formattedDateTime);
    const formatDate = (date) => {
      const pad = (num) => num.toString().padStart(PADSTART, "0");
      return `${date.getFullYear()}-${pad(date.getMonth() + ONE_VALUE)}-${pad(
        date.getDate()
      )}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
    };

    setMinDate(formatDate(sixMonthsAgo));
    setMaxDate(formatDate(today));
  }, []);

  const columns = buildColumns(translate);
  const actions = buildActions(translate);

  return (
    <Observer>
      {() => {
        return (
          <>
            <CustomTable
              store={myStore}
              columnsWithoutPin={columns}
              loading={myStore.loading}
              filterDisplayValues={{}}
              selectedFiltersDisplay={{}}
              filters={{}}
              pinningInitialState={PINNING_INITIAL_STATE}
              setParentSelectedValues={setParentSelectedValues}
              actions={actions}
              prefix={TABLE_CONFIG.prefix}
              title={translate("reconciliation-streams.title")}
              pinCondition={(row) => {
                return false;
              }}
              maxTableHeight={TABLE_CONFIG.maxHeight}
              expandedViewRow={(row, context, actionFunctions) => {
                return (
                  <ExpandedViewRow
                    row={row}
                    context={context}
                    actionFunctions={actionFunctions}
                    translate={translate}
                  />
                );
              }}
              pinnedRowHeight={TABLE_CONFIG.pinnedRowHeight}
              showFilter={TABLE_CONFIG.showFilter}
              language={i18n.language}
              hideActionOnRow={(row) => {
                const statusTag = row.original.ReconciliationStreamStatusTag;
                return statusTag === "DISABLED";
              }}
            />
          </>
        );
      }}
    </Observer>
  );
};

export default ReconciliationStreamsComponent;
